import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import Close from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';

const CompactDialog = ({
  open,
  onClose,
  title,
  topIcon: TopIcon,
  topIconProps,
  children,
  maxWidth = 700,
  hideCloseButton = false,
  titleColor = 'common.white',
  titleBackgroundColor = 'primary.main',
  spacing = 3,
  contentPadding = 3,
  ...dialogProps
}) => {
  const TopIconComponent = TopIcon?.icon || TopIcon;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 6,
          width: { xs: '100%', md: maxWidth },
          maxWidth: { xs: '100%', md: maxWidth },
          margin: { xs: 0, md: 'auto' },
          position: { xs: 'fixed', md: 'relative' },
          bottom: { xs: 0, md: 'auto' },
        },
      }}
      {...dialogProps}
    >
      <DialogTitle
        component="div"
        sx={{
          borderRadius: '6px 6px 0 0',
          bgcolor: titleBackgroundColor,
          py: spacing,
          px: spacing,
        }}
      >
        <Stack spacing={spacing} alignItems="center" width="100%">
          {TopIconComponent && (
            <TopIconComponent {...(TopIcon?.props || topIconProps || {})} />
          )}
          {typeof title === 'string' ? (
            <Typography color={titleColor} align="center" variant="h4">
              {title}
            </Typography>
          ) : (
            title
          )}
        </Stack>
        {!hideCloseButton && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: spacing,
              top: spacing,
              color: titleColor,
            }}
          >
            <Close />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent
        sx={{
          p: contentPadding,
          backgroundColor: 'white',
        }}
      >
        <Stack spacing={spacing} width="100%">
          {children}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

CompactDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  topIcon: PropTypes.oneOfType([
    PropTypes.elementType,
    PropTypes.shape({
      icon: PropTypes.elementType,
      props: PropTypes.shape({}),
    }),
  ]),
  topIconProps: PropTypes.shape({}),
  children: PropTypes.node,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hideCloseButton: PropTypes.bool,
  titleColor: PropTypes.string,
  titleBackgroundColor: PropTypes.string,
  spacing: PropTypes.number,
  contentPadding: PropTypes.number,
};

CompactDialog.defaultProps = {
  title: '',
  topIcon: undefined,
  topIconProps: undefined,
  children: null,
  maxWidth: 700,
  hideCloseButton: false,
  titleColor: 'common.white',
  titleBackgroundColor: 'primary.main',
  spacing: 3,
  contentPadding: 3,
};

export default CompactDialog;
